import React, { Component } from 'react';
import './Style.css';
import '../../../custom.css'
import { Alert } from '../../Utils/Alert';
import { Loading } from '../../Utils/Loading';
import Goal from '../../../images/goal.svg'
import Winner from '../../../images/winner.svg'


export class PlanDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            planId: window.location.href.substring(window.location.href.lastIndexOf('/') + 1),
            firstTime: true,
            selectedDay: {},
            loading: false,
            model: null,
            progress: [],
            alert: {
                Title: '',
                Body: '',
                Type: '',
                Show: false
            }
        }

    }

    componentDidMount() {
        this.GetPlanSubscribe(1);
    }

    async GetPlanSubscribe(day) {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Plan/GetDetailByPlanId?planId=${this.state.planId}&day=${day}`, request);

        this.setState({ loading: false });

        if (response.status == 200) {
            const data = await response.json();

            var progress = [];
            data.activities.forEach((obj, index) => {
                obj.acti.forEach((item) => { progress.push(item); });
            });

            this.setState({ model: data, selectedDay: data.activities.find(c => c.day == day), progress: progress });
            if (this.state.firstTime) {
                window['afterRender']();
            }
            this.setState({ firstTime: false });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'obteniendo el detalle del plan.',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async InsertActivityToUser(model) {
        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },

            body: JSON.stringify(model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Plan/InsertActivityToUser`, request);

        this.setState({ loading: false });

        if (response.status == 200) {

            if (this.state.currentControl.nextElementSibling != null) {
                this.state.currentControl.nextElementSibling.click();
            } else {
                this.setState({ daySuccess: true, internal: null, currentControl: null, planSuccess: this.state.model.plan.numberOfDays == this.state.internal.day });
            }



            this.setState({
                alert: {
                    Title: 'Éxito',
                    Body: 'Progreso guardado con éxito',
                    Type: 'alert-success',
                    Show: true
                }
            });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Error registrando el progreso, inténtelo de nuevo',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }
    render() {

        return (
            <div className="mt-5">

                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="/comunidad">Inicio</a></li>
                        <li class="breadcrumb-item"><a href="/comunidad/plan">Planes</a></li>
                        <li class="breadcrumb-item active" aria-current="page">{this.state.model ? this.state.model.plan.title : null}</li>

                        <li class="miga-more-option">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-three-dots" viewBox="0 0 16 16">
                                <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                            </svg>
                        </li>
                    </ol>
                </nav>

                <div className="wrapp-detail-plan" hidden={this.state.internal || this.state.daySuccess}>

                    <div className="form-group row photo-plan">
                        {this.state.model ? <h4 className="text-center">{this.state.model.plan.title}</h4> : null}
                    </div>

                    <div className="form-group row photo-plan">
                        <img src={this.state.model ? this.state.model.plan.photo : null} />
                    </div>

                    <div className="form-group row plan-header mt-5">
                        <div className="col-6 text-center">
                            <p><b>Cuantas personas han realizado este plan:</b> {this.state.model ? this.state.model.plan.subscription : null}</p>
                        </div>
                        <div className="col-6 text-center">
                            <p><b>Creado por:</b> {this.state.model ? this.state.model.plan.author : null} PL {this.state.model ? this.state.model.plan.plNumber : null}</p>
                        </div>
                    </div>

                    <div className="form-group row plan-header mt-5">
                        <b>Mi progreso</b>
                    </div>

                    <div class="form-group row">
                        {this.state.model ?

                            <div class="progress-bar" role="progressbar"
                                style={{ "width": parseInt((100 / this.state.progress.length) * this.state.progress.filter(a => a.done).length) + '%' }}
                                aria-valuenow={parseInt((100 / this.state.progress.length) * this.state.progress.filter(a => a.done).length)}
                                aria-valuemin="0" aria-valuemax="100">{parseInt((100 / this.state.progress.length) * this.state.progress.filter(a => a.done).length)}%
                            </div> : null}
                    </div>


                    <div className="form-group row photo-plan">
                        {this.state.model ? <p className="pre-line-text">{this.state.model.plan.description}</p> : null}
                    </div>

                    <ol class="list-group list-group-numbered demo mt-5">
                        {
                            this.state.model ?

                                this.state.model.activities.map((a) =>
                                    <li class={`cursor-pointer list-group-item ${a.day == this.state.selectedDay.day ? 'active' : null}`} onClick={item => {
                                        this.GetPlanSubscribe(a.day);
                                    }} >

                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar2-day mr-2" viewBox="0 0 16 16">
                                            <path d="M4.684 12.523v-2.3h2.261v-.61H4.684V7.801h2.464v-.61H4v5.332h.684zm3.296 0h.676V9.98c0-.554.227-1.007.953-1.007.125 0 .258.004.329.015v-.613a1.806 1.806 0 0 0-.254-.02c-.582 0-.891.32-1.012.567h-.02v-.504H7.98v4.105zm2.805-5.093c0 .238.192.425.43.425a.428.428 0 1 0 0-.855.426.426 0 0 0-.43.43zm.094 5.093h.672V8.418h-.672v4.105z" />
                                            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z" />
                                            <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4z" />
                                        </svg>

                                        Día {a.day}
                                        {
                                            a.acti.filter(c => !c.done).length == 0 ?
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-all" viewBox="0 0 16 16">
                                                    <path d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z" />
                                                </svg>
                                                : null
                                        }
                                    </li>
                                )


                                : null
                        }
                    </ol>

                    <ol class="list-group list-group-numbered ">
                        {
                            this.state.selectedDay.acti ?

                                this.state.selectedDay.acti.map((e, i) =>

                                    <li className="list-group-item list-group-item-success border-bottom row cursor-pointer" onClick={(a) => {
                                        this.setState({ internal: e, currentControl: a.currentTarget, titleInternal: a.target.innerText })
                                    }} >
                                        <div className="row">
                                            <div className="col-11">
                                                {e.isMotivational ? 'Motivaticional' : `Actividad ${i}`}
                                            </div>
                                            <div className="col-1">
                                                {
                                                    e.done ?
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-all" viewBox="0 0 16 16">
                                                            <path d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992a.252.252 0 0 1 .02-.022zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486-.943 1.179z" />
                                                        </svg>
                                                        : null
                                                }
                                            </div>
                                        </div>
                                    </li>

                                )
                                : null
                        }
                    </ol>
                </div>

                <div className="internal mt-5" hidden={!this.state.internal} >
                    <div className="form-group row col-12">
                        <button type="button" class="btn btn-secondary" onClick={() => {
                            this.setState({ internal: null, daySuccess: false });
                            this.GetPlanSubscribe(this.state.selectedDay.day);
                        }} >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left-short" viewBox="0 0 16 16" >
                                <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"></path>
                            </svg>

                        </button>
                        <h2 className="text-center">{this.state.titleInternal}</h2>
                    </div>

                    <div className="form-group row col-12">

                        <p className="pre-line-text">
                            {
                                this.state.internal ?
                                    this.state.internal.description
                                    : null
                            }
                        </p>
                    </div>

                    <div className="ixed-bottom">

                        <button type="button" class="btn btn-success" onClick={() => {
                            this.InsertActivityToUser({ ActivityId: this.state.internal.id, UserPlanId: parseInt(this.state.planId) });
                        }} >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2-all" viewBox="0 0 16 16">
                                <path d="M12.354 4.354a.5.5 0 0 0-.708-.708L5 10.293 1.854 7.146a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0l7-7zm-4.208 7-.896-.897.707-.707.543.543 6.646-6.647a.5.5 0 0 1 .708.708l-7 7a.5.5 0 0 1-.708 0z" />
                                <path d="m5.354 7.146.896.897-.707.707-.897-.896a.5.5 0 1 1 .708-.708z" />
                            </svg>

                        </button>

                    </div>
                </div>

                <div className="internal mt-5" hidden={!this.state.daySuccess || this.state.planSuccess}>
                    <div className="form-group row">
                        <img src={this.state.internal ? this.state.internal.photo : null} />
                    </div>
                    <div className="form-group row text-center">
                        <img className="not-found" src={Goal} />
                    </div>
                    <div className="form-group row text-center">
                        <h4>
                            Ya estas más cerca de completarlo
                        </h4>
                    </div>

                    <div className="form-group row text-center">
                        <input type="button" value="Continuar" className="btn btn-primary" onClick={() => { this.setState({ daySuccess: false }); this.GetPlanSubscribe(this.state.selectedDay.day); }} />
                    </div>
                </div>

                <div className="internal mt-5" hidden={!this.state.planSuccess}>
                    <div className="form-group row">
                        <img src={this.state.internal ? this.state.internal.photo : null} />
                    </div>
                    <div className="form-group row text-center">
                        <img className="not-found" src={Winner} />
                    </div>
                    <div className="form-group row text-center">
                        <h4>
                            <b>Felicidades</b> lo haz logrado, haz completado el plan
                        </h4>
                    </div>

                    <div className="form-group row text-center">
                        <input type="button" value="Continuar" className="btn btn-primary" onClick={() => { window.location.href = '/comunidad/plan' }} />
                    </div>
                </div>


                {this.state.alert.Show ? <Alert Title={this.state.alert.Title} Type={this.state.alert.Type} Body={this.state.alert.Body} callBack={() => { this.setState({ alert: { show: false } }) }}/> : null}
                {this.state.loading ? <Loading /> : null}

            </div >
        );
    }
}
